module.exports = __webpack_public_path__ + "img/northport-logo.66c679b5.jpg";